var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1758_1720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 1.16602C4.54992 1.16602 2.33325 3.04435 2.33325 5.94935C2.33325 7.88602 3.89075 10.1785 6.99992 12.8327C10.1091 10.1785 11.6666 7.88602 11.6666 5.94935C11.6666 3.04435 9.44992 1.16602 6.99992 1.16602ZM6.99992 6.99935C6.35825 6.99935 5.83325 6.47435 5.83325 5.83268C5.83325 5.19102 6.35825 4.66602 6.99992 4.66602C7.64159 4.66602 8.16659 5.19102 8.16659 5.83268C8.16659 6.47435 7.64159 6.99935 6.99992 6.99935Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1758_1720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlack);
export default __webpack_public_path__ + "static/media/locationBlack.bd9eb6adefabd7bd526dbf7121c66665.svg";
export { ForwardRef as ReactComponent };